// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + {"70":"05c8dac361ad83321ed5","190":"5ad93550b0d866a7e9cc","549":"20e94c23b29f25ca398a"}[chunkId] + ".js";
};